import React from 'react';
import _ from 'lodash';
//import { Link } from 'react-router-dom';

export function process(obj) {
	if (!_.isObject(obj)) { return; }
	const text = obj.text || "";
	const entities = obj.entities || [];

	const ret = [];

	let lastCharEnd = 0;
	entities.forEach((entity, i) => {
		const {
			charStart,
			charEnd,
			//entityId,
			//entityKey
		} = entity;

		const before = text.slice(lastCharEnd, charStart);
		const chunk = text.slice(charStart, charEnd + 1);

		lastCharEnd = charEnd + 1;
		ret.push(<span key={`before${i}`}>{before}</span>);

		const key= `chunk${i}`;
		/*
		if (entityKey === 'userId') {
			ret.push(<Link key={key} to={`/user/update/${entityId}`}>{chunk}</Link>);
		} else if (entityKey === 'equipmentId') {
			ret.push(<Link key={key} to={`/equipment/truck/update/${entityId}`}>{chunk}</Link>);
		} else {
			ret.push(<span key={key}>{chunk}</span>);
		}
		 */
		ret.push(<span key={key} style={{fontWeight : 600}}>{chunk}</span>);



	});

	ret.push(<span key='end'>{text.slice(lastCharEnd, text.length)}</span>);

	return ret;
}